import React from 'react'
import { useTranslation } from 'react-i18next'

import { SEND_OPINION } from '~/api/opinion'

import { useFormErrorState, useFormState } from '~/common/form/formCommon'
import {
  convertToOpinionRequestValues,
  initialData,
  OpinionType,
  opinionValidation
} from '~/components/app/form/opinion/opinionType'
import { STD_FILE_SETS } from '~/common/form/formUpload'
import Form from '~/components/app/form/base/Form'
import SupportButton from '~/components/atoms/button/SupportButton'
import { ButtonType } from '~/components/atoms/button/ButtonBase'
import FormFileUpload from '~/components/molecules/form/upload/FormFileUpload'
import FormTextArea from '~/components/molecules/form/textarea/FormTextArea'
import ActionButton from '~/components/atoms/button/ActionButton'
import FormSide from '~/components/wrapper/form/FormSide'
import FormRow from '~/components/wrapper/form/FormRow'
import { TextAreaRow } from '~/components/atoms/textarea/TextArea'

interface Props {
  setRequested(requested: boolean): void
}

const OpinionForm = ({setRequested}: Props) => {
  const { t } = useTranslation()
  const [formData, setData] = useFormState<OpinionType>(initialData)
  const [formError, setError] = useFormErrorState()

  const complete = () => {
    setRequested(true)
  }

  const convertToRequestValues = (type: OpinionType) => {
    return convertToOpinionRequestValues(type, location.pathname, navigator.userAgent)
  }

  return (
    <Form
      mutation={SEND_OPINION}
      complete={() => complete()}
      convertToRequestValues={convertToRequestValues}
      formData={formData}
      formError={formError}
      setData={setData}
      setError={setError}
      validations={opinionValidation}
      uploadFileSets={STD_FILE_SETS}
    >
      <FormRow>
        <FormTextArea
          name="opinion"
          value={formData.opinion}
          onChange={setData}
          onError={setError}
          rows={TextAreaRow.WIDE}
        />
      </FormRow>
      <FormSide>
        <FormFileUpload
          name="file_data"
          fileName="file_path"
          value={formData.file_data}
          onChange={setData}
          errors={formError.formWidgetErrors.file_path}
          onError={setError}
        >
          <SupportButton type={ButtonType.BUTTON}>
            {t('file.select')}
          </SupportButton>
        </FormFileUpload>
        <ActionButton type={ButtonType.SUBMIT}>
          {t('action.send')}
        </ActionButton>
      </FormSide>
    </Form>
  )
}

export default OpinionForm
